import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import { RootState } from "@/store";

interface PublicRouteProps {
  children: ReactNode;
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, isLoading, user } = useSelector(
    (state: RootState) => state.auth,
  );
  const location = useLocation();

  // Avoid redirect races while auth is being initialized.
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <span className="loading loading-spinner loading-lg text-primary"></span>
          <p className="mt-4 text-base-content/70">Loading...</p>
        </div>
      </div>
    );
  }

  // If user is already authenticated, redirect to dashboard
  // Check if there's a 'from' location in state, otherwise go to home
  const requestedFrom = (location.state as any)?.from?.pathname;
  const from = requestedFrom?.startsWith("/auth/") ? "/" : requestedFrom || "/";

  if (isAuthenticated && user) {
    return <Navigate replace to={from} />;
  }

  return <>{children}</>;
}
